import { combineReducers } from 'redux-immutable';

import conversation from './conversation';
import perm from './perm';
import stream from './stream';
import customer from './customer';
import personalConfig from './personal-config';
import payment from './payment';

export default combineReducers({
  customer,
  conversation,
  perm,
  stream,
  personalConfig,
  payment
});
